import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, TextKey } from '@mews-commander/enums';
import { isCurrentEnterprisePortfolio } from '@mews-commander/legacy-entities';
import {
    PortfolioRolesListHeader,
    PropertyRolesLayout,
    RolesList,
    RolesProvider,
} from '@mews-commander/modules/src/modules/roles';
import { DialogProvider, PortfolioLayout, QueryBoundary, SuspenseBoundary } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Roles/Index/')({
    component: Component,
    staticData: {
        title: TextKey.Roles,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});

function Component() {
    const isPortfolio = useCommanderSelector(isCurrentEnterprisePortfolio);
    const guideLink = createGuideLink(ArticlePath.SetUpAndCustomizeRolesMultiProperty);

    return (
        <RolesProvider>
            <DialogProvider>
                <QueryBoundary>
                    {isPortfolio ? (
                        <PortfolioLayout>
                            <PortfolioRolesListHeader guideLink={guideLink} />
                            <SuspenseBoundary>
                                <RolesList />
                            </SuspenseBoundary>
                        </PortfolioLayout>
                    ) : (
                        <PropertyRolesLayout>
                            <SuspenseBoundary>
                                <RolesList />
                            </SuspenseBoundary>
                        </PropertyRolesLayout>
                    )}
                </QueryBoundary>
            </DialogProvider>
        </RolesProvider>
    );
}
